import styled from 'styled-components';
import { CardImg, Card, ProductName } from '../../theme/theme'

type CardContentProps = {
    minWidth?: string,
    discount?: number | null,
    secondImage?: string,
    src?: string | null,
    bgColor?: string,
    showInGrid?: boolean,
    showInLine?: boolean,
}

const CardContent = styled(Card)<CardContentProps>`
    min-width: ${props => props.minWidth ??  '25%'}; 
    margin-right: ${props => props.minWidth ? '0.5vh' : 'auto'};
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    @media (max-width: 1367px) {
        min-width: 21vh;
        margin-left: 1vh;
    }
`

type ProductCardImageProps = {
    width?: string,
    maxHeight?: string,
    showInGrid?: boolean,
    alt?: string
}

const ProductCardImage = styled(CardImg)<ProductCardImageProps>`
    object-fit: cover;
    width: ${props => props.width ? props.width: '37vh'};
    height: ${props => props.width ? props.width: '37vh'};
    border-radius: 8px;
    margin: 0;
    background-image:url(${props => props.src});
    background-size: cover;
    background-repeat: round;
    @media (max-width: 1367px) {
        width: 100%;
        height: 100%;
    }
`
type ProductCardImageContainerProps = {
    width?: string;
}

const ProductCardImageContainer = styled.a<ProductCardImageContainerProps>`
    height: auto;
    /* width: ${props  => props.width ?? '30vh'}; */
    position: relative;
    @media (max-width: 1367px) {
        width: 20vh;
        height: 20vh;
    }
`

const ProductCardName = styled(ProductName)`
    word-break: break-all;
    font-size: 0.8rem;
`

const ProductPrice = styled.div`
    font-weight: bold;
    font-size: 1rem;
`

export { CardContent, ProductCardName, ProductCardImage, ProductCardImageContainer, ProductPrice }